// Helper function to fix API URL construction
const getAPIUrl = (baseUrl) => {
  // Fall back to a relative '/api' base when BACKEND_URL is undefined/empty
  // so this never throws at module load.
  if (!baseUrl) {
    return '/api';
  }
  // Check if BACKEND_URL already contains /api to avoid duplication
  return baseUrl.endsWith('/api') ? baseUrl : `${baseUrl}/api`;
};

export default getAPIUrl;
